import { Navigate } from "react-router-dom";
import { useSessionSwitcher } from "@/contexts/SessionSwitcherContext";

export default function AnalyzaRiscResolver() {
  const { currentSessionId, isLoadingSessions } = useSessionSwitcher();

  if (isLoadingSessions) {
    return null;
  }

  if (currentSessionId) {
    return <Navigate to={`/analiza-risc/${currentSessionId}`} replace />;
  }

  return <Navigate to="/identificare-raportare" replace />;
}
